import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { CommonModule } from "@angular/common";
import { IconModule } from "@shared/components/icon/icon.module";

export interface DeactivateDialogData {
	count: number;
	confirmButtonText: string;
	backButtonText: string;
	confirmationMessage: string;
}

@Component({
	selector: "app-deactivate-employees-confirmation-dialog",
	templateUrl: "./deactivate-employees-confirmation-dialog.component.html",
	styleUrls: ["./deactivate-employees-confirmation-dialog.component.scss"],
	standalone: true,
	imports: [CommonModule, MatDialogModule, MatButtonModule, IconModule]
})
export class DeactivateEmployeesConfirmationDialogComponent {
	data = inject<DeactivateDialogData>(MAT_DIALOG_DATA);
}
